module.exports = __webpack_public_path__ + "4c1e78d823ecb6383e3bebdb4e362ef0.svg";